import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';
import socket from 'config/socket';

import {
  GET_EXPENSES, ADD_EXPENSE/*, DELETE_EXPENSE*/
} from 'redux/actionTypes';
import { incrementIDGen, incrementIDGenSocket } from '.';
import { expense } from 'constants/idGenType';
import { standard } from 'constants/userAccountTypes';

export const getExpenses = () => (dispatch, getState) => {
  axiosClient
    .get('/api/expenses', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_EXPENSES,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const getExpensesAdmin = () => (dispatch, getState) => {
  axiosClient
    .get('/api/expenses/admin', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_EXPENSES,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addExpense = (newExpense, adminId) => (dispatch, getState) => {
  axiosClient
    .post('/api/expenses', newExpense, tokenConfig(getState))
    .then(res => {
      dispatch(incrementIDGen({ id: res.data.userId, field: expense }));
      dispatch({
        type: ADD_EXPENSE,
        payload: res.data
      });
      // Socket will emit to admin for "Petty_Expense" of standard users.
      if( getState().activeUserType === standard ) {
        socket.emit('private-request', {
          request: 'add-expense',
          userId: adminId,
          data: res.data
        });
      }
      // Socket will emit to standard users when Type is supposed to be added to them.
      else if( !newExpense.addToSelf ) {
        socket.emit('private-request', {
          request: 'add-expense',
          userId: res.data.userId,
          data: res.data
        });
      }
    })
    .catch(err => console.log(err))
};

export const addExpenseSocket = (newExpense) => dispatch => {
  dispatch({
    type: ADD_EXPENSE,
    payload: newExpense
  });

  dispatch(incrementIDGenSocket({ user: newExpense.userId, field: expense }));
};

/*
export const deleteExpense = (data) => (dispatch, getState) => {
  Axios
    .patch('/api/expenses/delete', data, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: DELETE_EXPENSE,
        payload: data.id
      });
    })
    .catch(err => console.log(err))
};*/